module.exports = __webpack_public_path__ + "static/media/silkycloud-red-3.b3642719.png";